export default "__VITE_ASSET__ChS5IvET__"